import $ from 'jquery';  // Import jQuery
import DataService from "./DataService/DataService";
import Main from "./Main";
import 'semantic-ui-css/semantic.min.js';  // Import only necessary JavaScript
import SubPage from './SubPage';
import MenuHistory from './MenuHistory';


window.onload = async () => {

    try {
        const countryData = await DataService.fetchData();
        window.menuHistory = new MenuHistory();
        const mainPage = new Main(countryData)

        $(document).ready(function () {
            $('.ui.dropdownCountryScore').dropdown({
                onChange: (value, text, $selectedItem) => {
                    disableMobileKeyboard()
                }
            });
            $('.ui.dropdownPolicy').dropdown({
                onChange: (value, text, $selectedItem) => {
                    disableMobileKeyboard()
                }
            });
            if (window.innerWidth <= 575) {
                $('.ui.dropdownRegion').dropdown({
                    direction: 'upward',
                    onChange: (value, text, $selectedItem) => {
                        disableMobileKeyboard()
                    }
                });
            } else {
                $('.ui.dropdownRegion').dropdown({
                    onChange: (value, text, $selectedItem) => {
                        disableMobileKeyboard()
                    }
                });
            }
            $('.ui.selectCountryMap').dropdown({
                onChange: (value, text, $selectedItem) => {
                    disableMobileKeyboard()
                }
            });

        });

        function disableMobileKeyboard() {
            if (window.innerWidth <= 992) {
                const activeElement = document.activeElement;

                // If an input or textarea is focused, blur it to close the keyboard
                if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
                    activeElement.blur();
                }
            }
        }

        // KEY INSIGHTS
        const contentBlocks = $('#key-insights .col-right .content-block');
        contentBlocks.find('.toggle-btn').on('click', (event) => {
            const $btn = $(event.currentTarget);  // The clicked toggle button
            const $contentBlock = $btn.closest('.content-block');  // The closest parent .content-block

            // Toggle the 'active' class on the parent .content-block
            $contentBlock.toggleClass('active');

            // Toggle the text of the button inside the .toggle-btn
            if ($contentBlock.hasClass('active')) {
                $btn.find('span').text('Read less');  // Change text to "Collapse"
            } else {
                $btn.find('span').text('Read more');  // Change text to "Read more"
            }
        });

        const implicationBackBtn = $('#policy-implications .bottom-row .backBtn')
        implicationBackBtn.on('click', () => {
            SubPage.getInstance().hidePolicyImplicationsPage()
        })

        if (window.innerWidth <= 992) {
            const keyIngishtsBackBtn = $('#key-insights .mobile-navigation .backBtn')
            keyIngishtsBackBtn.on('click', () => {
                SubPage.getInstance().hideKeyInsightsPage()
            })
        } else {
            const keyIngishtsBackBtn = $('#key-insights .col-left .backBtn')
            keyIngishtsBackBtn.on('click', () => {
                SubPage.getInstance().hideKeyInsightsPage()
            })
        }


    } catch (err) {
        console.error("Failed to initialize CountryData:", err.message);
    }

}

